module.exports = __webpack_public_path__ + "img/green-3-squiggly-striped.76b73973.svg";